import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import ModalSearchMask from 'ferries/Home/components/FerrySearchMask/Mobile/ModalSearchMask';

const DatePickerModal = ({
  showDatePicker, displayValues, toggleDatePicker, children, translations
}) => (
  <>
    <div
      className="form-control form-control-lg rounded-0 input-icon input-icon-flip pr-6"
      onClick={toggleDatePicker}
    >
      <div className="text-truncate">
        {displayValues}
      </div>
      <span className="icon icon-calendar-2" aria-hidden="true"></span>
    </div>
    <ModalSearchMask
      show={showDatePicker}
      title={translations.selectDates}
      toggleModal={toggleDatePicker}
      classes={{content: 'bg-snow'}}
    >
      {children}
    </ModalSearchMask>
  </>
);

DatePickerModal.defaultProps = {
  roundTrip: false  
};

DatePickerModal.propTypes = {
  showDatePicker: PropTypes.bool.isRequired,
  displayValues: PropTypes.string.isRequired,
  toggleDatePicker: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ]).isRequired,
  translations: PropTypes.shape({
    selectDates: PropTypes.string.isRequired
  })
};

export default observer(DatePickerModal);
